import React from 'react';
import { Box, Typography } from '@heycater/design-system';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { DAYS_OF_WEEK } from 'shared/constants';

const toTwentyFourHourTimeFormat = (amPmString = '') => {
  const amPmRegex = /([0-9:]+(am|pm))/gi;

  return amPmString.replace(amPmRegex, (match) => {
    const isPm = match.toLowerCase().includes('pm');
    match = match.replace(/(pm|am)/gi, () => '');
    let date = new Date(`1/1/2022 ${match}:00`);
    if (isPm) {
      date = new Date(date.getTime() + 12 * 3600 * 1000);
    }
    return date.toLocaleTimeString('de-DE', {
      hour: 'numeric',
      minute: '2-digit',
    });
  });
};

const CatererDeliverySchedule = ({ deliverySchedule }) => {
  const { t } = useTranslation('caterers');

  return (
    <Box>
      <StyledHeader>{t('caterer.deliveryScheduleHeader')}</StyledHeader>
      <StyledGrid>
        {DAYS_OF_WEEK.map((day) => (
          <>
            <Typography>{t(`common:days_of_week.${day}`)}</Typography>
            <Typography>
              {toTwentyFourHourTimeFormat(deliverySchedule[day])}
            </Typography>
          </>
        ))}
      </StyledGrid>
    </Box>
  );
};

const StyledHeader = styled(Typography)`
  font-size: ${(props) => props.theme.typography.h6.fontSize};
  font-weight: ${(props) => props.theme.typography.h6.fontWeight};
  margin-bottom: ${(props) => props.theme.spacing(1)}px;
`;

const StyledGrid = styled(Box)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: ${(props) => props.theme.spacing(3)}px;
  row-gap: ${(props) => props.theme.spacing(1)}px;
`;

export default CatererDeliverySchedule;
